import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    XtremePushBannerButton,
    XtremePushBannerDisclaimer,
    XtremePushBannerHeader,
    XtremePushBannerHeaderWrapper,
    XtremePushBannerIcon,
    XtremePushBannerTitleWrapper,
    XtremePushBonusContainer,
} from './XtremePushBanner.style';
import { useCommon } from 'src/domains/common/Common';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

interface XtremePushBannerPropsType {
    type: 'casino' | 'sportsbook';
}

export const XtremePushBanner = observer('XtremePushBanner', (props: XtremePushBannerPropsType) => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const { xtremePushState } = appLayoutsState;
    return (
        <XtremePushBonusContainer>
            <XtremePushBannerHeaderWrapper>
                <XtremePushBannerIcon />
                <XtremePushBannerTitleWrapper>
                    <XtremePushBannerHeader>Try your luck for free rewards!</XtremePushBannerHeader>
                    <XtremePushBannerDisclaimer>Ts&Cs apply</XtremePushBannerDisclaimer>
                </XtremePushBannerTitleWrapper>
            </XtremePushBannerHeaderWrapper>
            <XtremePushBannerButton
                onClick={(): void => xtremePushState.startGame(props.type)}
                appearance='secondary'
                size='medium'
            >
                Play For Free
            </XtremePushBannerButton>
        </XtremePushBonusContainer>
    );
});
